module.exports = __webpack_public_path__ + "img/GAME_RAINWINDOW2.c33fe09b.jpg";